import {Component, Inject, Input, Output, EventEmitter, OnInit} from 'ng-metadata/core';
import {FavoritesService} from '../../../favorites/favorites.service';
import {FavoritesEditLabelsMenuService} from '../../../favorites/favoritesEditLabelsMenu/favoritesEditLabelsMenu.service';
import {BriefResultService} from '../../briefResult/briefResult.service';
import {SearchService} from '../../search.service';

@Component({
    selector: 'prm-search-result-add-to-favorites-menu',
    templateUrl: 'components/search/searchResult/searchResultAddToFavoritesMenu/search-result-add-to-favorites-menu.html',
})

export class PrmSearchResultAddToFavoritesMenu implements OnInit {

    private originatorEv: any;
    private newLabel: string;
    private label: string;

    @Output() onAddToFavoritesEvent = new EventEmitter();
    @Input() isSection: boolean;
    @Input() disable: boolean;

    private KEY_CODE = {
        COMMA: 188,
        SEMICOLON: 186,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT_ARROW: 37,
        UP_ARROW: 38,
        RIGHT_ARROW: 39,
        DOWN_ARROW: 40,
        TAB: 9,
        BACKSPACE: 8,
        DELETE: 46
    };

    constructor(
        private favoritesEditLabelsMenuService: FavoritesEditLabelsMenuService,
        private briefResultService: BriefResultService,
        private favoritesService: FavoritesService,
        private searchService: SearchService,
        @Inject('featuredActionsIcons') private actionsIcons,
        @Inject('favoritesIcons') private  favoritesIcons: Object[],
        @Inject('$scope') private $scope: ng.IScope,
        @Inject('$mdMenu') private $mdMenu: ng.material.IMenuService,
        @Inject('$translate') private $translate: ng.translate.ITranslateService) {
        this.favoritesService.updateLabelsFromAPI();
    }

    ngOnInit() {
        this.$scope.$watch(() => this.briefResultService.pinnedToFav, (newVal, oldVal) => {
            if (newVal) {
                if (this.label) {
                    this.addLabel(this.label);
                }
                this.newLabel = '';
                this.$mdMenu.hide();
            }
        });
    }

    openMenu($mdOpenMenu, ev) {
        if (!this.disable) {
            this.originatorEv = ev;
            $mdOpenMenu(ev);
        }
    };

    pinToFavoritesFromMenu() {
        document.querySelector('#addFavAndLabeluser').focus();
        return this.onAddToFavoritesEvent.emit(event);
    }

    returnAssignedLabels() {
        return this.favoritesEditLabelsMenuService.returnAssignedLabels(this.isSection);
    }

    returnOtherLabels() {
        return this.favoritesEditLabelsMenuService.returnOtherLabels(this.isSection);
    }

    removeLabelForOneRecord(recordId, label) {
        this.favoritesEditLabelsMenuService.removeLabelForOneRecord(recordId, label);
    }

    removeLabel(label) {
        this.favoritesEditLabelsMenuService.removeLabel(label, this.isSection);
    }

    addLabelForOneRecord(recordId, label) {
        this.favoritesEditLabelsMenuService.addLabelForOneRecord(recordId, label);
    }

    addLabelAfterPinned(label ?) {
        this.label = label ? label : this.newLabel;
    }

    addLabel(label) {
        this.favoritesEditLabelsMenuService.addLabel(label, this.isSection);
    }

	public isChosenFavAndLabels(){
		return this.favoritesEditLabelsMenuService.isChosenFavAndLabels(this.disable);
	}

    public isChosenLabels() {
        return this.favoritesEditLabelsMenuService.isChosenLabels(this.disable);
	}

    private get searchInProgress() {
        return this.searchService.isSearchInProgress();
    }

    private keydownSupport(e) {    
        
         let keyCodes = this.KEY_CODE;
         let menuItems = document.querySelectorAll('#menuContent md-menu-item button');
        
        switch (e.keyCode) {
            case keyCodes.UP_ARROW:
                e.preventDefault();
                return menuItems[menuItems.length - 1].focus();
                break;
            case keyCodes.DOWN_ARROW:
                e.preventDefault();
                return document.querySelector('#labelInput').focus();
                break;
            case keyCodes.TAB:
                e.preventDefault();
                return document.querySelector('#addToFavUser').focus();
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultAddToFavoritesMenu/searchResultAddToFavoritesMenu.directive.ts